import { Grid, Typography, Checkbox, Button } from "@material-ui/core";
import Collapse from "@material-ui/core/Collapse";
import { styled } from "@material-ui/core/styles";
import ExpandMore from "@material-ui/icons/ExpandMore";
import IconButton from "@material-ui/core/IconButton";
import { Autocomplete } from "@material-ui/lab";
import TextField from "@material-ui/core/TextField";
import { useSelector } from "react-redux";
import useCustomState from "../../hooks/State";
import { useDispatch } from "react-redux";
import {
  UpdateShowProjectWaterCountersListMode,
  UpdateShowProjectPowerCountersListMode,
  UpdateShowProjectGasCountersListMode,
} from "../../store/actions";
import Loading6 from "../../assets/loading/loading6.gif";
import Call from "../../service/API";
import { useMountAPI } from "../../hooks/APICall";
import { convertNumbers } from "../../utils/ConvertNumbers";
import { CheckBox, Info } from "@material-ui/icons";
import { Link } from "react-router-dom";
import { Split } from "../../utils/Split";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import {
  BLACK,
  BLUE_COLOR,
  DARK_SIDEBAR,
  ERROR_COLOR,
  GREEN_PRIMRY,
  ORANGE_COLOR,
  usersPageSize, // for pagination
  SILVER_TABLE_COLOR,
  WHITE,
} from "../../utils/const";
import CorrectCheck from "../../assets/img/correct-check.png";
import HazardCheck from "../../assets/img/error-blink-5.gif";
import ReceiptIcon from "@material-ui/icons/Receipt";
import moment from "jalali-moment";
import { defaultSettings, getProjectUnits } from "../../utils/getUnits";

const ExpandMoree = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const CategoricalCounters = (props) => {
  const dispatch = useDispatch();

  // -----------------------------------------------------------------------------------------------

  const Expanded = useCustomState(false);
  const handleExpandClick = () => {
    Expanded.handleChange(!Expanded.value);
  };

  const showOnlySelectedCounters = useCustomState(false);

  const showOnlySelectedCountersChanged = (e) => {
    if (e.target.checked) {
      showOnlySelectedCounters.handleChange(true);
    } else {
      showOnlySelectedCounters.handleChange(false);
    }
  };

  const selectedCounters = useCustomState([]);

  const selectCounter = (e) => {
    const serial = e.target.id;
    const sc = selectedCounters.value;
    if (e.target.checked) {
      // push new counter into the selected list
      const cs = consumptions.value.filter((c) => c[0] === serial);
      if (cs.length > 0) {
        sc.push(cs[0]);
      }
      selectedCounters.handleChange(sc);
    } else {
      // remove counter from selected list
      const newsc = sc.filter((c) => c[0] !== serial);
      selectedCounters.handleChange(newsc);
    }
  };

  // ------------------------------------------------------------------------------------

  const waterShowListMode = useSelector(
    (state) => state.componentStates.showProjectWaterCountersTableMode
  );

  const powerShowListMode = useSelector(
    (state) => state.componentStates.showProjectPowerCountersTableMode
  );

  const gasShowListMode = useSelector(
    (state) => state.componentStates.showProjectGasCountersTableMode
  );

  let showListMode;
  if (props.category.name.includes("آب")) {
    showListMode = waterShowListMode;
  } else if (props.category.name.includes("برق")) {
    showListMode = powerShowListMode;
  } else if (props.category.name.includes("گاز")) {
    showListMode = gasShowListMode;
  } else {
    showListMode = true;
  }

  // ------------------------------------------------------------------------------------------------

  const showWaterTableListModeChanged = (e) => {
    dispatch(
      UpdateShowProjectWaterCountersListMode({
        showProjectWaterCountersTableMode: e.target.checked,
      })
    );
  };

  const showPowerTableListModeChanged = (e) => {
    dispatch(
      UpdateShowProjectPowerCountersListMode({
        showProjectPowerCountersTableMode: e.target.checked,
      })
    );
  };

  const showGasTableListModeChanged = (e) => {
    dispatch(
      UpdateShowProjectGasCountersListMode({
        showProjectGasCountersTableMode: e.target.checked,
      })
    );
  };

  const showListModeChanged = (e) => {
    if (props.category.name.includes("آب")) {
      showWaterTableListModeChanged(e);
    } else if (props.category.name.includes("برق")) {
      showPowerTableListModeChanged(e);
    } else if (props.category.name.includes("گاز")) {
      showGasTableListModeChanged(e);
    }
  };

  // -------------------------------------------------------------------------------------------------

  const sortingFilters = useCustomState([
    {
      name: "counterRegister",
      farsiName: "تاریخ ثبت کنتور",
      value: null,
    },
    {
      name: "lastConsumption",
      farsiName: "آخرین میزان مصرف",
      value: "last_consumption",
    },
    {
      name: "monthConsumption",
      farsiName: "میزان مصرف ماه جاری",
      value: "month",
    },
    {
      name: "totalConsumption",
      farsiName: "کل میزان مصرف",
      value: "year",
    },
  ]);

  const sortingDirection = useCustomState([
    {
      name: "descending",
      farsiName: "نزولی",
      value: true,
    },
    {
      name: "ascending",
      farsiName: "صعودی",
      value: false,
    },
  ]);

  const selectedSortingFilter = useCustomState(sortingFilters.value[0]);
  const sortingFilterError = useCustomState({ error: false, text: "" });

  const selectedSortingDirection = useCustomState(sortingDirection.value[0]);
  const sortingDirectionError = useCustomState({ error: false, text: "" });

  const sortingFilterChanged = (e, newValue) => {
    sortingFilterError.handleChange({ error: false, text: "" });
    selectedSortingFilter.handleChange(newValue);
  };

  const sortingDirectionChanged = (e, newValue) => {
    sortingDirectionError.handleChange({ error: false, text: "" });
    selectedSortingDirection.handleChange(newValue);
  };

  // ----------------------------------------------------------------------------------------------

  const consumptionIsLoading = useCustomState(true);
  const consumptions = useCustomState([]);

  const consumptionUtils = {
    isLoading: consumptionIsLoading,
    consumptionInfo: consumptions,
    projectId: props.projectId,
    categoryId: props.category.id,
    sortValue: selectedSortingFilter.value.value,
    descending: selectedSortingDirection.value.value,
    page: 1,
    count: 1000,
  };

  useMountAPI(fetchConsumptions, consumptionUtils);

  const counters = props.counters.filter(
    (c) => c.categoryId === props.category.id
  );
  const e = Expanded.value;

  const applySortingFilters = (e) => {
    consumptionIsLoading.handleChange(true);
    consumptionUtils.sortValue = selectedSortingFilter.value.value;
    consumptionUtils.descending = selectedSortingDirection.value.value;
    fetchConsumptions(consumptionUtils);
  };

  // ------------------------------------------------------------------------------------------------
  // Renders

  const renderExpandIcons = (category) => {
    return (
      <ExpandMoree
        expand={Expanded.value}
        onClick={handleExpandClick}
        aria-expanded={Expanded.value}
        aria-label="show more"
      >
        <ExpandMore />
      </ExpandMoree>
    );
  };

  // ---------------------------------------------------------------------------------------------

  const renderShowListMode = () => {
    const ch = showListMode;
    const onChange = showListModeChanged;
    return (
      <Grid
        item
        style={{
          paddingRight: "8px",
          paddingLeft: "8px",
          marginBottom: "24px",
        }}
        sx={12}
        sm={12}
        md={12}
        lg={12}
      >
        <Grid
          style={{ fontSize: "14px", color: "#73879c" }}
          container
          direction="row"
          alignItems="center"
        >
          <Grid style={{ marginLeft: "2px" }} item>
            <Checkbox onChange={onChange} color="primary" checked={ch} />
          </Grid>
          <Grid item>
            <span style={{ fontWeight: "bold" }}>نمایش جدولی</span>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderSortingFilters = () => {
    return (
      <Grid
        item
        style={{
          paddingRight: "8px",
          paddingLeft: "8px",
          marginBottom: "24px",
        }}
        sx={12}
        sm={12}
        md={12}
        lg={12}
      >
        <Grid
          style={{ fontSize: "14px", color: "#73879c" }}
          container
          direction="row"
          alignItems="center"
        >
          <Grid style={{ marginLeft: "16px", marginTop: "24px" }} item>
            <span style={{ fontWeight: "bold" }}>مرتب سازی بر اساس: </span>
          </Grid>
          <Grid sx={3} sm={3} md={3} lg={3}>
            <Autocomplete
              onChange={sortingFilterChanged}
              value={selectedSortingFilter.value}
              options={sortingFilters.value}
              getOptionLabel={(option) => option.farsiName}
              renderInput={(params) => (
                <TextField
                  error={sortingFilterError.value.error}
                  helperText={sortingFilterError.value.text}
                  {...params}
                  label="فیلتر بر اساس"
                  variant="standard"
                />
              )}
            />
          </Grid>
          <Grid
            style={{
              marginLeft: "16px",
              marginRight: "24px",
              marginTop: "24px",
            }}
            item
          >
            <span style={{ fontWeight: "bold" }}>به صورت: </span>
          </Grid>
          <Grid sx={3} sm={3} md={3} lg={3}>
            <Autocomplete
              onChange={sortingDirectionChanged}
              value={selectedSortingDirection.value}
              options={sortingDirection.value}
              getOptionLabel={(option) => option.farsiName}
              renderInput={(params) => (
                <TextField
                  error={sortingDirectionError.value.error}
                  helperText={sortingDirectionError.value.text}
                  {...params}
                  label="فیلتر به صورت"
                  variant="standard"
                />
              )}
            />
          </Grid>
          <Grid
            style={{
              marginLeft: "16px",
              marginRight: "24px",
              marginTop: "24px",
            }}
            item
          >
            <Button
              onClick={applySortingFilters}
              style={{ backgroundColor: BLUE_COLOR, color: WHITE }}
            >
              اعمال فیلترها
            </Button>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderOnlyShowSelectedCounters = () => {
    return (
      <Grid
        item
        style={{
          paddingRight: "8px",
          paddingLeft: "8px",
          marginBottom: "24px",
        }}
        sx={12}
        sm={12}
        md={12}
        lg={12}
      >
        <Grid
          style={{ fontSize: "14px", color: "#73879c" }}
          container
          direction="row"
          alignItems="center"
        >
          <Grid style={{ marginLeft: "2px" }} item>
            <Checkbox
              onChange={showOnlySelectedCountersChanged}
              color="primary"
              checked={showOnlySelectedCounters.value}
            />
          </Grid>
          <Grid item>
            <span style={{ fontWeight: "bold" }}>
              تنها موارد انتخاب شده را نمایش بده
            </span>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderUnitInfo = () => {
    const projectUnitInfo = getProjectUnits(
      props.project.water_meter_project_other_information
    );
    let unitInfo, color;
    if (props.category.name.includes("آب")) {
      unitInfo = projectUnitInfo.water;
      color = BLUE_COLOR;
    } else if (props.category.name.includes("برق")) {
      unitInfo = projectUnitInfo.power;
      color = ERROR_COLOR;
    } else if (props.category.name.includes("گاز")) {
      unitInfo = projectUnitInfo.gas;
      color = ORANGE_COLOR;
    } else {
      unitInfo = defaultSettings;
      color = BLACK;
    }
    return (
      <Grid
        item
        style={{
          paddingRight: "8px",
          paddingLeft: "8px",
          marginBottom: "24px",
        }}
        sx={12}
        sm={12}
        md={12}
        lg={12}
      >
        <Grid
          style={{ fontSize: "14px", color: "#73879c" }}
          container
          direction="row"
          alignItems="center"
        >
          <Grid item>
            <span style={{ fontWeight: "normal" }}>
              * مقادیر مصرف ذکر شده در جدول زیر بر حسب
            </span>
            <span style={{ color: color, fontWeight: "bold" }}>
              {" " + unitInfo.unit + " "}
            </span>
            <span>هستند.</span>
          </Grid>
        </Grid>
      </Grid>
    );
  };

  const renderHeaderOptions = (category) => {
    return (
      <>
        {renderShowListMode()}
        {renderSortingFilters()}
        {renderOnlyShowSelectedCounters()}
        {renderUnitInfo()}
        <div
          style={{
            width: "100%",
            marginBottom: "24px",
            border: "1px solid #333",
          }}
        ></div>
      </>
    );
  };

  // --------------------------------------------------------------------------------------------

  const renderLoading = () => {
    return (
      <Grid container>
        <div
          style={{
            width: "100%",
            height: "260px",
            marginTop: "48px",
            backgroundColor: "#fff",
            borderRadius: "12px",
            position: "relative",
          }}
        >
          <img
            src={Loading6}
            style={{
              width: "180px",
              height: "180px",
              position: "absolute",
              left: "50%",
              top: "50%",
              transform: "translate(-50%, -50%)",
            }}
            alt="Loading..."
          />
        </div>
      </Grid>
    );
  };

  const renderTableView = (counters) => {
    const cs = showOnlySelectedCounters.value ? selectedCounters : consumptions;
    const projectUnitInfo = getProjectUnits(
      props.project.water_meter_project_other_information
    );
    let unitInfo, color;
    if (props.category.name.includes("آب")) {
      unitInfo = projectUnitInfo.water;
      color = BLUE_COLOR;
    } else if (props.category.name.includes("برق")) {
      unitInfo = projectUnitInfo.power;
      color = ERROR_COLOR;
    } else if (props.category.name.includes("گاز")) {
      unitInfo = projectUnitInfo.gas;
      color = ORANGE_COLOR;
    } else {
      unitInfo = defaultSettings;
      color = BLACK;
    }
    return (
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 700 }} aria-label="customized table">
          <TableHead style={{ backgroundColor: DARK_SIDEBAR, color: WHITE }}>
            <TableRow>
              <TableCell style={{ color: WHITE, width: "10px" }} align="center">
                <CheckBox />
              </TableCell>
              <TableCell style={{ color: WHITE }}>#</TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                نام کنتور
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                شماره سریال
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                ثبت آخرین مصرف در
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                آخرین مصرف
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                مصرف ماه جاری
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                مصرف کل
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                صدور قبض
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                صحت مقادیر مصرف
              </TableCell>
              <TableCell style={{ color: WHITE }} align="center">
                مشاهده جزئیات
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {cs.value.map((c, idx) => {
              if (c.length !== 2) {
                return null;
              } else {
                const serial = c[0];
                const consInfo = c[1];
                let counterInfo = counters.filter((c) => c.serial === serial);
                if (counterInfo.length === 0) {
                  return null;
                }
                counterInfo = counterInfo[0];
                // ----------------------------------------------------------------
                let yearConsumption,
                  monthConsumption,
                  dayConsumption,
                  lastConsumption,
                  lastDate,
                  totalConsumption;
                // ------------------------------------------------------------------
                let image;
                if (consInfo !== undefined) {
                  yearConsumption = consInfo.cumulative_consumptions.year[1];
                  monthConsumption = consInfo.cumulative_consumptions.month[1];
                  dayConsumption = consInfo.cumulative_consumptions.day[1];
                  lastConsumption = consInfo.last_consumption
                    ? consInfo.last_consumption.value
                    : 0;
                  totalConsumption = consInfo.total_value;
                  const cumulative_consumption = consInfo.last_consumption
                    ? consInfo.last_consumption.cumulative_value
                    : 0;
                  if (counterInfo.category.includes("آب")) {
                    image =
                      totalConsumption === cumulative_consumption
                        ? CorrectCheck
                        : HazardCheck;
                  } else {
                    image = CorrectCheck;
                  }
                  if (consInfo.last_consumption) {
                    lastDate = (
                      <>
                        <span>
                          {convertNumbers(
                            moment(consInfo.last_consumption.create_time)
                              .locale("fa")
                              .format("YYYY/MM/DD")
                          )}
                        </span>
                        <br />
                        <span>
                          {convertNumbers(
                            moment(consInfo.last_consumption.create_time)
                              .locale("fa")
                              .format("HH:mm:ss")
                          )}
                        </span>
                      </>
                    );
                  } else {
                    lastDate = "ثبت نشده";
                  }
                } else {
                  yearConsumption = 0;
                  monthConsumption = 0;
                  dayConsumption = 0;
                  lastConsumption = 0;
                  lastDate = "ثبت نشده";
                }
                // const s = selectedCounters.value.filter((c) => c[0] === serial);
                // let boxChecked = false;
                // if (s.length > 0) {
                //   boxChecked = true;
                // }
                let cb;
                if (showOnlySelectedCounters.value) {
                  cb = (
                    <input
                      type={"checkbox"}
                      onChange={selectCounter}
                      id={counterInfo.serial}
                      checked={true}
                      style={{ width: "18px", height: "18px" }}
                    />
                  );
                } else {
                  const s = selectedCounters.value.filter(
                    (c) => c[0] === serial
                  );
                  if (s.length > 0) {
                    cb = (
                      <input
                        type={"checkbox"}
                        onChange={selectCounter}
                        id={counterInfo.serial}
                        style={{ width: "18px", height: "18px" }}
                        checked={true}
                      />
                    );
                  } else {
                    cb = (
                      <input
                        type={"checkbox"}
                        onChange={selectCounter}
                        id={counterInfo.serial}
                        style={{ width: "18px", height: "18px" }}
                      />
                    );
                  }
                }

                const fLastConsumption = Number(
                  Number(lastConsumption) / Number(unitInfo.factor)
                );
                const fMonthConsumption = Number(
                  Number(monthConsumption) / Number(unitInfo.factor)
                );
                const fTotalConsumption = Number(
                  Number(totalConsumption) / Number(unitInfo.factor)
                );

                const roundedLastConsumption =
                  unitInfo.float === 0
                    ? Math.ceil(fLastConsumption)
                    : Number(fLastConsumption.toFixed(unitInfo.float));

                const roundedMonthConsumption =
                  unitInfo.float === 0
                    ? Math.ceil(fMonthConsumption)
                    : Number(fMonthConsumption.toFixed(unitInfo.float));

                const roundedTotalConsumption =
                  unitInfo.float === 0
                    ? Math.ceil(fTotalConsumption)
                    : Number(fTotalConsumption.toFixed(unitInfo.float));

                return (
                  <TableRow>
                    <TableCell style={{ fontWeight: "bold" }} align="center">
                      {cb}
                    </TableCell>
                    <TableCell style={{ fontWeight: "bold" }}>
                      {convertNumbers(idx + 1)}
                    </TableCell>
                    <TableCell align={"center"} style={{ fontWeight: "bold" }}>
                      {convertNumbers(counterInfo.name)}
                    </TableCell>
                    <TableCell align={"center"}>{counterInfo.serial}</TableCell>
                    <TableCell align={"center"}>{lastDate}</TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(Split(roundedLastConsumption))}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(Split(roundedMonthConsumption))}
                    </TableCell>
                    <TableCell align={"center"}>
                      {convertNumbers(Split(roundedTotalConsumption))}
                    </TableCell>
                    <TableCell align={"center"}>
                      <Link
                        to={"/admin/counter/" + counterInfo.serial + "/bills"}
                      >
                        <ReceiptIcon
                          style={{
                            color: ORANGE_COLOR,
                            cursor: "pointer",
                            fontSize: "28px",
                          }}
                        />
                      </Link>
                    </TableCell>
                    <TableCell align={"center"}>
                      <img src={image} width={30} height={30} />
                    </TableCell>
                    <TableCell align={"center"}>
                      <Link
                        to={
                          "/admin/project-dash/" +
                          props.projectId +
                          "/counters/" +
                          counterInfo.serial
                        }
                      >
                        <Info
                          style={{
                            color: BLUE_COLOR,
                            cursor: "pointer",
                            fontSize: "28px",
                          }}
                        />
                      </Link>
                    </TableCell>
                  </TableRow>
                );
              }
            })}
          </TableBody>
        </Table>
      </TableContainer>
    );
  };

  const renderCardView = (counters) => {
    return null;
  };

  const renderView = (category, counters) => {
    if (!consumptionIsLoading.value) {
      if (showListMode) {
        return renderTableView(counters);
      } else {
        return renderCardView(counters);
      }
    } else {
      return <>{renderLoading()}</>;
    }
  };

  return (
    <Grid
      item
      xs={12}
      sm={12}
      md={12}
      lg={12}
      style={{ marginBottom: "24px", marginTop: "12px" }}
    >
      <Typography style={{ fontSize: "20px", fontWeight: "bold" }}>
        <span>{props.category.name !== "سایر" ? "لیست کنتورهای " : ""}</span>
        <span>{props.category.name}</span>
        {renderExpandIcons(props.category)}
      </Typography>
      <hr />
      <Collapse in={e} timeout="auto" unmountOnExit>
        <Grid container>
          {renderHeaderOptions(props.category)}
          {renderView(props.category, counters)}
        </Grid>
      </Collapse>
    </Grid>
  );
};

export default CategoricalCounters;

const fetchConsumptions = (utils) => {
  const isLoading = utils.isLoading;
  const info = utils.consumptionInfo;
  const page = utils.page;
  const count = utils.count;
  const projectId = utils.projectId;
  const categoryId = utils.categoryId;
  const sortValue = utils.sortValue;
  const descending = utils.descending;

  const data = {
    page: page,
    count: count,
    project_id: projectId,
    user_id: null,
    water_meter_serial: null,
    water_meter_tag: categoryId,
    sort_value: sortValue,
    reverse: descending,
  };

  Call("POST", "watermeters/admin/cumulative/consumption", data)
    .then((response) => {
      // console.log("consumption info: ", response);
      if (response.data.code === 200) {
        const consumptionInfo = response.data.data;
        if (consumptionInfo.length > 0) {
          info.handleChange(consumptionInfo);
        } else {
          info.handleChange([]);
        }
      }
      isLoading.handleChange(false);
    })
    .catch((error) => {
      if (error.response) {
        const data = error.response.data;
        // console.log(data);
      }
    });
};
